module.exports = __webpack_public_path__ + "img/afterSales.914a41e6.png";